<template>
  <div class="inline-block">
    <button
      class="inline-flex items-center text-white px-3 py-1 text-sm rounded-sm bg-blue-600 hover:bg-blue-700 hover:text-white transition-colors duration-150 focus:outline-none"
      @click="openModal"
    >
      Edit
    </button>

    <Portal to="app-dialog">
      <PageEditModal v-if="open" :page-id="pageId" @close="closeModal" />
    </Portal>
  </div>
</template>

<script>
import PageEditModal from './PageEditModal.vue';

export default {
  components: {
    PageEditModal,
  },
  props: {
    pageId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    setOpen(open) {
      this.open = open;
    },
    openModal() {
      this.setOpen(true);
    },
    closeModal() {
      this.setOpen(false);
    },
  },
};
</script>
